module.exports = __webpack_public_path__ + "static/media/image5.5009ce13.JPG";